const requiredValidator = {
  attribute: "required",
  key: "valueMissing",
  isValid(instance, value) {
    let valid = true;
    if ((instance.hasAttribute("required") || instance.required) && !value) {
      valid = false;
    }
    return valid;
  }
};
const minLengthValidator = {
  attribute: "minlength",
  key: "rangeUnderflow",
  isValid(instance, value) {
    if (!value) {
      return true;
    }
    if (value && instance.minLength > value.length) {
      return false;
    }
    return true;
  }
};
const maxLengthValidator = {
  attribute: "maxlength",
  key: "rangeOverflow",
  isValid(instance, value) {
    if (!instance.maxLength) {
      return true;
    }
    if (!!value && instance.maxLength < value.length) {
      return false;
    }
    return true;
  }
};
const patternValidator = {
  attribute: "pattern",
  key: "patternMismatch",
  isValid(instance, value) {
    if (!value || !instance.pattern) {
      return true;
    }
    const regExp = new RegExp(instance.pattern);
    return !!regExp.exec(value);
  }
};
const validateEmail = (email) => {
  const format = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return email.match(format);
};
const emailValidator = {
  attribute: "email",
  key: "typeMismatch",
  isValid(instance, value) {
    if (!value || instance.type !== "email") {
      return true;
    }
    return !!validateEmail(value);
  }
};
const validateURL = (url) => {
  try {
    new URL(url);
    return true;
  } catch (err) {
    return false;
  }
};
const urlValidator = {
  attribute: "url",
  key: "badInput",
  isValid(instance, value) {
    if (!value || instance.type !== "url") {
      return true;
    }
    return validateURL(value);
  }
};
export {
  emailValidator,
  maxLengthValidator,
  minLengthValidator,
  patternValidator,
  requiredValidator,
  urlValidator
};
//# sourceMappingURL=validators.js.map
